import {
	INSTRUMENT_ICONS_MAPPING,
	BadgeStatus,
	BadgeVariants,
} from '../constants';

export const getPaymentFilterIcon = (filterEnum?: string) => {
	const imgSrc =
		(filterEnum
			? INSTRUMENT_ICONS_MAPPING[
					filterEnum as keyof typeof INSTRUMENT_ICONS_MAPPING
				]
			: INSTRUMENT_ICONS_MAPPING.OTHERS) || INSTRUMENT_ICONS_MAPPING.OTHERS;
	return {
		renderer: <img width={24} height={24} src={imgSrc} alt={filterEnum} />,
		imgSrc,
	};
};

export const getStatusVariant = (status: string | number) => {
	switch (status) {
		case BadgeStatus.PENDING:
		case BadgeStatus.DEEMED:
		case BadgeStatus.INITIATED:
		case BadgeStatus.PROCESSING:
		case BadgeStatus.QUEUED:
		case BadgeStatus.IN_PROGRESS:
			return BadgeVariants.WARNING;
		case BadgeStatus.ERRORED:
		case BadgeStatus.FAILED:
		case BadgeStatus.CANCELLED:
			return BadgeVariants.ERROR;
		case BadgeStatus.COMPLETED:
		case BadgeStatus.APPROVED:
		default:
			return BadgeVariants.SUCCESS;
	}
};
